export default "__VITE_ASSET__742db48e__"